import { Box, FormHelperText, Typography } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import moment from 'moment';
import React, { ReactElement } from 'react';

type DatePickerProps = {
  placeHolder?: string;
  onChange?: (src: any) => void;
  value?: any;
  error?: any;
  name?: string;
  minDate?: any;
  maxDate?: any;
  disabled?: boolean;
};

const DatePickerCom = (props: DatePickerProps): ReactElement => {
  const {
    placeHolder,
    onChange,
    value,
    error,
    name,
    minDate,
    maxDate,
    disabled = false,
  } = props;

  return (
    <Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Custom input"
          value={value}
          minDate={minDate && new Date(minDate)}
          maxDate={maxDate && new Date(maxDate)}
          onChange={onChange}
          disabled={disabled}
          renderInput={({ inputRef, inputProps, InputProps }) => (
            <Box
              sx={{
                '& .MuiInputAdornment-positionEnd': {
                  alignItems: 'center',
                  alignSelf: 'center',
                  justifyContent: 'center',
                  marginLeft: '20px',
                  width: '20%',
                },
                '& button': {
                  marginLeft: '-20px',
                },
                '& input': {
                  border: 'unset !important',
                  fontSize: '12px !important',
                  width: '90px !important',
                },
                '& svg': {
                  color: '#005EBF !important',
                },
                alignItems: 'center',
                background: '#f8f8fa',
                borderRadius: '10px',
                display: 'flex',
                width: '120px !important',
              }}>
              {InputProps?.endAdornment}
              <input
                ref={inputRef}
                {...inputProps}
                name={name}
                placeholder={placeHolder}
                disabled
              />
            </Box>
          )}
        />
      </LocalizationProvider>
      {error && <FormHelperText className="errorText">{error}</FormHelperText>}
    </Typography>
  );
};

export default DatePickerCom;
